import dynamic from 'next/dynamic';

import { WhitePanel } from 'components/Toolkit/WhitePanel/WhitePanel';
import { ValueCar } from './components/ValueCar/ValueCar';
import { useCarValuationTool } from './CarValuationTool.hook';
import { Skeleton } from './components/Skeleton';
import { NetworkError } from './components/NetworkError';
import { UserVehicle } from './components/UserVehicle/UserVehicle';

const ValueCarModal = dynamic(
  import('./components/ValueCarModal/ValueCarModal').then(
    (mod) => mod.ValueCarModal,
  ),
);

const CarValuationTool = (props: { emailResponse: boolean }) => {
  const { emailResponse } = props;

  const {
    isLoading,
    carValuationData,
    isError,
    errorOnClickHandler,
    carValuationToolRef,
  } = useCarValuationTool();

  return (
    <>
      <WhitePanel className="common-margin-bottom" ref={carValuationToolRef}>
        {!isLoading && !carValuationData && !isError && <ValueCar />}
        {isLoading && <Skeleton />}
        {carValuationData && (
          <UserVehicle {...carValuationData} emailResponse={emailResponse} />
        )}
        {isError && <NetworkError onClick={errorOnClickHandler} />}
      </WhitePanel>
      <ValueCarModal />
    </>
  );
};

export { CarValuationTool };
